import React, { useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  Autocomplete
} from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const CustomerInformation = ({
  creditNote,
  customers,
  controlStyle,
  onCustomerChange
}) => {
  const { t } = useTranslation();
  // Log when creditNote changes to track data flow
  useEffect(() => {
    console.log('CustomerInformation: creditNote changed', creditNote);
    if (creditNote && creditNote.customer) {
      console.log('CustomerInformation: customer data received', creditNote.customer);
    }
  }, [creditNote]);
  // Create a safe customer object to prevent null reference errors
  const customer = creditNote.customer || {};

  // Check if we have any customer data to display
  const hasCustomerData = customer && (
    customer.customerName ||
    customer.vat ||
    customer.customerPhone ||
    customer.customerAddress
  );

  return (
    <Paper
      elevation={0}
      sx={{
        p: 0.5,
        mb: 0.5,
        borderRadius: '4px',
        boxShadow: 'none',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
      }}
    >
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5, fontSize: '0.875rem' }}>
        {t('Common.Customer_Information')}
      </Typography>
      <Grid container spacing={0.5}>
        {hasCustomerData ? (
          <>
            <Grid item xs={12}>
              <TextField
                label={t('Common.Customer_Name')}
                value={customer.customerName || ''}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
                margin="dense"
                size="small"
                required
                sx={controlStyle}
              />
            </Grid>
            <Grid item xs={12}>
              {customer.vat ? (
                <TextField
                  label={t('Common.VAT_Number')}
                  value={customer.vat || ''}
                  fullWidth
                  margin="dense"
                  size="small"
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={controlStyle}
                />
              ) : (
                <TextField
                  label={t('Common.Phone_Number')}
                  value={customer.customerPhone || ''}
                  fullWidth
                  margin="dense"
                  size="small"
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={controlStyle}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={t('Common.Address')}
                value={customer.customerAddress || ''}
                fullWidth
                multiline
                rows={2.5}
                margin="dense"
                size="small"
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  ...controlStyle,
                  '& .MuiOutlinedInput-root': {
                    minHeight: 70,
                    borderRadius: 0
                  }
                }}
              />
            </Grid>
          </>
        ) : (
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              {t('CreditNotes.Select_an_invoice_to_display_customer_information')}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default CustomerInformation;
